import React from "react";
import { Button, Checkbox, Col, DatePicker, Divider, Flex, Form, Input, message, Modal, notification, Radio, RadioChangeEvent, Row, Select, Space, Spin, Table, Upload, UploadProps } from 'antd';
import Column from "antd/es/table/Column";
import { storedArray$ } from "../../utils/helpers";
import { pricingCategory } from "../../enums/pricing.enum";
import ListApi from "../../api-services/list-api.service";
import Cookies from "js-cookie"
import { mdiMenuDown, mdiUpload } from "@mdi/js";
import Icon from "@mdi/react";
import B2C2BApi from "../../api-services/b2c2b-api.service";
import { Link, useParams } from "react-router-dom";
import { bookingFormValidationMessages, b2c2bDateFormat, b2c2bUploadProps, passportExpiryDisabledDates, phoneNumberRule } from "../../utils/antd.props";
import AgeValidatorField from "./b2c2b/AgeValidatorField";
import PhoneNumberInput from "../../components/shared/PhoneNumberInput";
import { InsuranceSection } from "./b2c2b/InsuranceSection";
import { Guest } from "../../interfaces/booking.interface";
import { useInsurance } from "../../services/InsuranceContext";
import dayjs from "dayjs";
import { Image } from 'antd';

const customCookies = Cookies.withAttributes({
  expires: 14
});

const getFile = (e) => e.file;

function withParams(Component) {
  return props => <Component {...props} params={useParams()} insurance={useInsurance()}/>;
}

class OrderInformationPage extends React.Component<{params, insurance}> {
  listApi = new ListApi;

  state = {
    loading: true, 
    submitLoading: false,
    titles: [],
    genders: [],
    states: [],
    cities: [],
    countries: [],
    filteredStates: [],
    filteredCities: [],
    filteredCountries: [],
    selectedState: "",
    selectedCity: "",
    selectedCountry: "",
    order: {id: null, booking: {}, flights: [], guests: [], departureDate: ""},
    isMalaysian: true,
    breakdownOpen: false,
  }

  componentDidMount() {
    const storedCities = customCookies.get("cities");

    B2C2BApi.viewBooking(this.props.params.id)
      .then(booking => {
        this.setState({order: booking});

        return Promise.all([
          this.listApi.getCountries(),
          storedCities == undefined ? this.listApi.getCities() : storedArray$(storedCities),
          this.listApi.getTitles(),
          this.listApi.getGenders(),
        ])
      })
    .then(([countries, cities, titles, genders]) => {
        const states = this.listApi.getStatesOptionsByCities(cities);
        customCookies.set('cities', JSON.stringify(cities))
        
        this.setState({countries, states, cities, filteredStates: states, filteredCities: cities, filteredCountries: countries, titles, genders})
      })
      .finally(() => {this.setState({loading: false})})
      .catch(error => {
        console.log(error)
        notification.error({ message: 'Something went wrong.'});
      });
  }

  submit = (formValues) => {
    this.setState({submitLoading: true})
    B2C2BApi.updateBooking(this.props.params.id, formValues)
      .then(response => {
        if(response.message && response.message === "success"){
          notification.success({message: "Booking updated successfully"});
        } else if(response.error){
          notification.error({message: response.error});
        }
      })
      .finally(() => {this.setState({submitLoading: false})})
  }

  handleFinishFailed = ({ errorFields }: { errorFields: any[] }) => {
    const hasShareError = errorFields.some(f =>
      Array.isArray(f.name) && f.name[f.name.length - 1] === '_share_total_check'
    );
    if (hasShareError) {
      const first = document.querySelector<HTMLElement>('[data-insurance-anchor]');
      first?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  PassengerForm(field, isEditable){
    const { titles, genders, countries, isMalaysian, order } = this.state;
    const firstPax = field.name == 0;
    const guest = order.guests[field.name] as Guest;
    const passportImage = guest?.passport_photocopy_image;
    const disabled = !isEditable;
    const insuranceAvailable = (order as any)?.insuranceAvailable;

    // Build guardian options: other guests + "None" option
    const guardianOptions = [
      ...(order.guests || [])
        .filter((g: Guest, i) => i !== field.name)
        .map((g: Guest) => ({ value: g.id, label: `${g.given_name} ${g.surname}` })),
      { value: 0, label: 'None' },
    ];
  
    return (
      <div className="b2c2b-section_panel-form">  
        <Space size={20} direction="vertical" style={{display: 'flex'}}>
          <Row gutter={[20, 20]}>
            <Col xs={24} lg={12}>
              <Form.Item name={[field.name, 'currency_total_price']}  label="Customer Price">
                <Input disabled/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item name={[field.name, 'category']}  label="Room Category">
                <Select disabled options={Object.entries(pricingCategory()).map(category => ({value: category[0], label: category[1]}))}/>
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left" orientationMargin="0">Personal Details</Divider>

          <Row gutter={[20, 20]}>
            <Col xs={24} lg={12}>
              <Form.Item label="Designation" name={[field.name, 'designation']} rules={[{required: true}]}>
                <Select disabled={disabled} suffixIcon={<Icon path={mdiMenuDown} size={1} />} placeholder="Select" options={titles}/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Surname on Passport" name={[field.name, 'surname']} rules={[{required: true}]}>
                <Input disabled={disabled} placeholder="Surname on Passport"/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Given name on Passport" name={[field.name, 'given_name']} rules={[{required: true}]}>
                <Input disabled={disabled} placeholder="Given name on Passport"/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Mobile Number" name={[field.name, 'mobile']} rules={[{required: firstPax}, phoneNumberRule]}>
                <PhoneNumberInput disabled={disabled} />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Email" name={[field.name, 'email']} rules={[{ type: 'email' }, {required: firstPax}]}>
                <Input disabled={disabled} placeholder="Email"/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
               <Form.Item label="Nationality" name={[field.name, 'nationality']} rules={[{required: true}]}>
                  <Select disabled={true} options={countries} placeholder="Nationality" onChange={(selected)=>this.setState({isMalaysian: selected == "Malaysia"})}/>
                </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="NRIC" name={[field.name, 'nric']} 
                rules={[{required: isMalaysian}, { pattern: /^\d{12}$/ }]}>
                <Input disabled={disabled} placeholder="900101010001" maxLength={12}/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <AgeValidatorField disabled={disabled} name={[field.name, 'date_of_birth']}/>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Passport Number" name={[field.name, 'passport_number']}>
                <Input disabled={disabled} placeholder="Passport Number"/>
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Passport Expiry" name={[field.name, 'passport_expiry_date']}>
                <DatePicker 
                  format={b2c2bDateFormat}                  
                  disabledDate={current => passportExpiryDisabledDates(current, order.departureDate)}
                  disabled={disabled}
                />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Passport Photocopy" name={[field.name, 'as_passport_photocopy']} getValueFromEvent={getFile} valuePropName="file" extra="format allowed: jpg.jpeg.gif.png.pdf.jfif">
                <Upload {...b2c2bUploadProps} maxCount={1} multiple={false} disabled={disabled}>
                  <Input disabled={disabled} placeholder="Click or drag file to this area to upload" prefix={<Icon path={mdiUpload} size="19px" />}/>
                </Upload>
              </Form.Item>
              {
                passportImage ? (
                  passportImage.includes("pdf") ? (
                    <a
                      href={passportImage}
                      target="_blank"
                    >
                      View passport
                    </a>
                  ) : (
                    <a
                      href={passportImage}
                      target="_blank"
                    >
                      <img
                        src={passportImage}
                        alt="Passport Image"
                      />
                    </a>
                  )
                ) : null
              }
            </Col>
            <Col xs={24} lg={12}>
              <Form.Item label="Insurance Certificate">
                {guest?.insurance_cert && guest?.policy_number ? (
                  <a
                    href={guest.insurance_cert}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {guest.policy_number}
                  </a>
                ) : (
                  <Input 
                    disabled={true} 
                    value={guest?.policy_number || "No Certificate Available"}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Remark" name={[field.name, 'customer_remark']}>
                <Input.TextArea disabled={true}/>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
              <Form.List name={[field.name, 'infant_bookings_attributes']}>
                {(subFields, subOpt) => (
                  <div className="infants-list">
                    {subFields.map((subField, index) => {
                      const infant = guest?.infant_bookings_attributes?.[subField.name] || {};

                      return (
                        <div key={index} className="infants-form">
                          <div className="infants-form_header">
                            <Divider orientation="left" orientationMargin="0">Infant {index+1} Details</Divider>
                            {/* <Button
                              color="primary"
                              variant="text"
                              icon={<Icon path={mdiAccountMinusOutline} size={1} />}
                              onClick={() => subOpt.remove(subField.name)}
                            /> */}
                          </div>
                          <Space size={20} direction="vertical" style={{display: 'flex'}}>
                            <Row key={subField.key} gutter={[20, 20]}>
                              <Col xs={24} lg={12}>
                                <Form.Item label="Surname on Passport" name={[subField.name, 'surname']} rules={[{required: true}]}> 
                                  <Input disabled={disabled} placeholder="Infants surname" />
                                </Form.Item>
                              </Col>
                              <Col xs={24} lg={12}>
                                <Form.Item label="Given name on Passport" name={[subField.name, 'given_name']} rules={[{required: true}]}> 
                                  <Input disabled={disabled} placeholder="Infants given name" />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row key={subField.key} gutter={[20, 20]}>
                              <Col xs={24} lg={12}>
                                <AgeValidatorField disabled={disabled} ageGroup="infant" name={[subField.name, 'date_of_birth']} departureDate={order.departureDate}/>
                              </Col>
                              <Col xs={24} lg={12}>
                                <Form.Item label="Gender" name={[subField.name, 'gender']} rules={[{required: true}]}> 
                                  <Select disabled={disabled} suffixIcon={<Icon path={mdiMenuDown} size={1} />} placeholder="Select" options={genders}/>
                                </Form.Item>
                              </Col>
                              <Col xs={24} lg={12}>
                                <Form.Item label="Insurance Certificate">
                                  {infant?.insurance_cert && infant?.policy_number ? (
                                    <a
                                      href={infant.insurance_cert}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {infant.policy_number}
                                    </a>
                                  ) : (
                                    <Input 
                                      disabled={true} 
                                      value={infant?.policy_number || "No Certificate Available"} 
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                            </Row>

                          {/* Insurance Section for Infant */}
                          {insuranceAvailable && (
                            <InsuranceSection
                              namePrefix={[subField.name]}
                              fieldPath={['guests', field.name, 'infant_bookings_attributes', subField.name]}
                              guardianType="infant"
                              parentGuestId={guest.id}
                              insurance={this.props.insurance}
                              disabled={disabled}
                            />
                          )}
                        </Space>
                      </div>
                    )})}
                    {/* <Button
                      className="add-infant-btn" 
                      color="primary" 
                      variant="outlined" 
                      onClick={() => subOpt.add()}>
                      <Icon path={mdiPlusCircleOutline} size="16px" /> 
                      Add Infant
                    </Button> */}
                  </div>
                )}
              </Form.List>
          </Form.Item>

          {/* Insurance Section — per pax */}
          {insuranceAvailable && (
            <InsuranceSection
              namePrefix={[field.name]}
              fieldPath={['guests', field.name]}
              guardianType="minor"
              guardianOptions={guardianOptions}
              insurance={this.props.insurance}
              disabled={disabled}
            />
          )}
        </Space>
      </div>
    )
  }

  BookingAddress(isEditable){
    const {filteredStates, filteredCities, filteredCountries} = this.state;
    const disabled = !isEditable;

    const filterCities = (selectedState) => {
      const storedCities = customCookies.get(`cities-${selectedState}`);
      (storedCities == undefined ? this.listApi.getCities({state: selectedState}) : storedArray$(storedCities))
        .then(filteredCities => {
          customCookies.set(`cities-${selectedState}`, JSON.stringify(filteredCities))
          this.setState({filteredCities, selectedState});
      });
    }

    const filterStates = (selectedCity, option) => {
      const {states, countries, selectedCountry} = this.state;
      var filteredStates = states;
      var filteredCountries = countries;

      if(selectedCity){
        filteredStates = states.filter(({value}) => value == option.state)
        filteredCountries = countries.filter(({value}) => value == option.country)
      }else{
        getCitiesByCountry(selectedCountry)
      }

      this.setState({filteredStates, filteredCountries, selectedCity})
    }

    const changeCountry = (selectedCountry) => {
      this.setState({selectedCountry})
      getCitiesByCountry(selectedCountry)
    }

    const getCitiesByCountry = (country) =>{
      const storedCitiesByCountry = customCookies.get(`cities-${country}`);
      Promise.all([
        (storedCitiesByCountry == undefined ? this.listApi.getCities({country}) : storedArray$(storedCitiesByCountry)),
      ])
        .then(([cities]) => {
          if(cities.length > 0)  customCookies.set(`cities-${country}`, JSON.stringify(cities))
          this.setState({cities, filteredCities: cities, country})
          
          const states = this.listApi.getStatesOptionsByCities(cities);
          this.setState({states, filterStates: states});
        })
    }

    return (
       <div id="booking-address">
         <div className="b2c2b-section_panel">
            <div className="b2c2b-section_panel-header">
              <label> Address <span className="address-label-note">*For e-invoice purpose only</span> </label>
            </div>
            <div className="b2c2b-section_panel-form">
                  <Row gutter={[20, 20]}>
                    <Col span={24}>
                      <Form.Item label={
                        <span>
                          Address 1
                        </span>} 
                        name={['bookingAddress', 'address_1']}>
                        <Input disabled={disabled} placeholder="Street address (e.g. No. 12, Jalan Ampang)"/>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item label="Address 2" name={['bookingAddress', 'address_2']}>
                        <Input disabled={disabled} placeholder="Apartment, suite, unit, block, floor, taman, kampung, etc. (optional)"/>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item label="State" name={['bookingAddress', 'state']}>
                        <Select
                          disabled={disabled}
                          suffixIcon={<Icon path={mdiMenuDown} size={1} />}
                          showSearch
                          allowClear
                          placeholder="Please Select"
                          options={filteredStates}
                          onChange={filterCities}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item label="City" name={['bookingAddress', 'city_name']}>
                        <Select
                          disabled={disabled}
                          suffixIcon={<Icon path={mdiMenuDown} size={1} />}
                          showSearch
                          allowClear
                          placeholder="Please Select"
                          options={filteredCities}
                          onChange={filterStates}
                          // filterOption={false}
                          // onSearch={fetchCities}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item label="Postcode" name={['bookingAddress', 'postal_code']}>
                        <Input disabled={disabled} type="number" placeholder="Postcode (e.g. 55100)" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                      <Form.Item label="Country" name={['bookingAddress', 'country']}>
                        <Select
                          disabled={disabled}
                          suffixIcon={<Icon path={mdiMenuDown} size={1} />}
                          showSearch
                          allowClear
                          placeholder="Please Select"
                          options={filteredCountries}
                          onChange={changeCountry}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
            </div>
          </div>
      </div>
    )
  }

  PaidAmountBreakdownModal(){
    const breakdown = (this.state.order as any)?.booking?.paidAmountBreakdown || [];

    return (
      <Modal
        title="Paid Amount Breakdown"
        open={this.state.breakdownOpen}
        onCancel={() => this.setState({ breakdownOpen: false })}
        footer={null}
        width={420}
      >
        <div className="price-breakdown">
          {breakdown.map((item, index) => (
            <div
              key={item.label}
              className={`price-breakdown_row${index === breakdown.length - 1 ? " price-breakdown_row-total" : ""}`}
            >
              <span>{item.label}</span>
              <span>{item.amount}</span>
            </div>
          ))}
        </div>
      </Modal>
    )
  }

  render(){
    const bookingOrder: any = this.state.order;
    const isEditable = !!bookingOrder?.editable;
    const status = bookingOrder?.booking?.status;
    const showPayNow = bookingOrder?.booking?.payableText === 'Payable';

    return (
      <div id="order-information" className="bookings-page b2c2b-section">
        {this.state.submitLoading ? <Spin spinning={this.state.submitLoading} fullscreen/> : null}
        <div className="bookings-page_header">
          <h1>Order Information</h1>

        </div>

        {
          this.state.loading ? <Spin spinning={this.state.loading} /> : (
            <Form
              layout="vertical"
              variant="filled"
              className="b2c2b"
              scrollToFirstError
              validateMessages={bookingFormValidationMessages}
              initialValues={bookingOrder}
              onFinishFailed={this.handleFinishFailed}
              onFinish={this.submit}>
                <Space size={40} direction="vertical" style={{ display: 'flex' }}>
                  <div className="bookings-page_table b2c2b-section_panel">
                    <label>Order Details</label>

                    <Space direction="vertical" size="large">
                      <Row>
                        <Col xs={24} sm={12}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Ref No.</span>
                            <span> {bookingOrder?.booking?.refNo} </span>
                          </div>
                        </Col>
                        {/* <Col xs={24} sm={12}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Name</span>
                            <span> {bookingOrder?.booking?.name} </span>
                          </div>
                        </Col> */}
                        <Col xs={24} sm={12}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Tour Code</span>
                            <span> {bookingOrder?.booking?.tourCode} </span>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Destination</span>
                            <span> {bookingOrder?.booking?.destination} </span>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="bookings-page_table-grid-cell full-width">
                            <span className="label">Package Name</span>
                            <span> {bookingOrder?.booking?.packageName} </span>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={24} sm={12}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Customer Fare</span>
                            <span> {bookingOrder?.booking?.fare} </span>
                          </div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Customer Fare Details</span>
                            <span> {bookingOrder?.booking?.fareDetails} </span>
                          </div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Paid Amount</span>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <span>{bookingOrder?.booking?.paidAmount}</span>
                              {bookingOrder?.booking?.paidAmountBreakdown?.length > 0 && (
                                <a
                                  onClick={() => this.setState({ breakdownOpen: true })}
                                  style={{ color: "#DC1A22", fontWeight: 600, textDecoration: "underline", cursor: "pointer", fontSize: 13 }}
                                >
                                  View payment breakdown
                                </a>
                              )}
                            </div>
                          </div>
                        </Col>
                        {bookingOrder?.booking?.adminFee && (
                          <Col xs={24} sm={12}>
                            <div className="bookings-page_table-grid-cell">
                              <span className="label">Admin Fee</span>
                              <span> {bookingOrder?.booking?.adminFee} </span>
                            </div>
                          </Col>
                        )}
                      </Row>

                      <Row>
                        <Col xs={24} sm={12}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Status</span>
                            <span> {bookingOrder?.booking?.status} </span>
                          </div>
                        </Col>
                        <Col xs={24} sm={12}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Sales Person</span>
                            <span> {bookingOrder?.booking?.salesPerson} </span>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="bookings-page_table-grid-cell">
                            <span className="label">Booked by</span>
                            <span> {bookingOrder?.booking?.bookedBy} </span>
                          </div>
                        </Col>
                      </Row>
                    </Space>

                    <label style={{ marginTop: '30px' }}>Agent Details</label>
                    <Row>
                      <Col xs={24} sm={12}>
                        <div className="bookings-page_table-grid-cell">
                          <span className="label">Agent Name</span>
                          <span> {bookingOrder?.agent?.name} </span>
                        </div>
                      </Col>
                      <Col xs={24} sm={12}>
                        <div className="bookings-page_table-grid-cell">
                          <span className="label">Contact No.</span>
                          <span> {bookingOrder?.agent?.contactNo} </span>
                        </div>
                      </Col>
                      <Col span={24}>
                        <div className="bookings-page_table-grid-cell full-width">
                          <span className="label">Agency Address</span>
                          <span> {bookingOrder?.agent?.address} </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  {
                    bookingOrder?.compulsoryTour?.set && bookingOrder.compulsoryTour.acknowledged && (
                      <div className="bookings-page_table b2c2b-section_panel compulsory-tour-charges">
                        <label>Compulsory Additional Tour Charges</label>
                        <div className="compulsory-tour-charges_lines">
                          {bookingOrder.compulsoryTour.lines.map((line: string, index: number) => <div key={index}>{line}</div>)}
                        </div>
                      </div>
                    )
                  }
                  {
                    bookingOrder?.flights.length > 0 && (
                      <div className="bookings-page_table b2c2b-section_panel">
                        <label>Flight Details <span className="note">*Flight schedule subject airlines</span></label>
                        <Table dataSource={bookingOrder?.flights} pagination={{position: ["none", "none"]}}>
                          <Column title="Departure" dataIndex="departure" key="departure" />
                          <Column title="Arrival" dataIndex="arrival" key="arrival" />
                          <Column title="From To" dataIndex="fromTo" key="fromTo" />
                          <Column title="Flight No" dataIndex="flightNo" key="flightNo" />
                          <Column title="Internal Remark" dataIndex="remark" key="remark" />
                        </Table>
                      </div>
                    )
                  }

                  <div id="passenger-info">
                    <Space size={20} direction="vertical" style={{display: 'flex'}}>
                      <Form.List name="guests">
                        {(fields, actions) => (
                          <Space size={20} direction="vertical" style={{display: 'flex'}}>
                            {
                              fields.map((field:any, index)=> (
                                <div key={index} className="b2c2b-section_panel">
                                  <div className="b2c2b-section_panel-header">
                                    <label>Guest {index+1}</label>
                                  </div>
                                  <div>
                                    {this.PassengerForm(field, isEditable)}
                                  </div>
                                </div>
                              ))
                            }
                          </Space>
                        )}
                      </Form.List>

                    {this.BookingAddress(isEditable)}

                  </Space>
                </div>


                
                <Flex align="center" justify="center" gap={10}>
                  {isEditable && (
                    <Button color="primary" htmlType="submit" variant="solid">Update</Button>
                  )}
                  {showPayNow && (
                    <Link to={`/web/bookings/${bookingOrder.id}/payment`}>
                      <Button color="primary" variant="outlined">Pay Now</Button>
                    </Link>
                  )}
                </Flex>
                </Space>            
            </Form>
          )
        }

        {this.PaidAmountBreakdownModal()}
      </div>
    )
  }
}

export default withParams(OrderInformationPage);
